type LockManagerWithRequest = LockManager & {
  request<T>(name: string, options: LockOptions, callback: () => Promise<T>): Promise<T>;
};

const inPageLocks = new Map<string, Promise<unknown>>();

export async function withWriteLock<T>(name: string, action: () => Promise<T>): Promise<T> {
  const lockManager = navigator.locks as LockManagerWithRequest | undefined;
  if (lockManager?.request) {
    return lockManager.request(`trenirovki:${name}`, { mode: 'exclusive' }, action);
  }

  const previous = inPageLocks.get(name) ?? Promise.resolve();
  let release: (() => void) | undefined;
  const current = new Promise<void>(resolve => { release = resolve; });
  const queued = previous.then(() => current);
  inPageLocks.set(name, queued);
  await previous;
  try {
    return await action();
  } finally {
    release?.();
    if (inPageLocks.get(name) === queued) inPageLocks.delete(name);
  }
}
